import * as React from 'react'

import {ButtonVideo} from '@/components/ButtonVideo/ButtonVideo'

const Iframe = ({...props}) => {
  const cover = props.cover
  if (props.iframe) {
    return (
      <div className='iframe-wrapper aspect-w-16 aspect-h-9 [&_iframe]:h-full [&_iframe]:w-full'>
        <ButtonVideo cover={props.cover} buttonLabel={props.buttonLabel} />
        <iframe
          allowFullScreen
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          title='youtube'
          data-requires-vendor-consent='youtube'
          data-src={props.iframe}
          style={{
            backgroundImage: cover.filename ? `url(${cover.filename})` : 'url(/iframePlayer.png)',
            backgroundSize: 'cover',
          }}
        />
      </div>
    )
  }

  return null
}

export default Iframe
